import { createFileRoute, redirect } from "@tanstack/react-router";

// Retired 2026-07-26: this route shipped hardcoded Spanish-only legal text
// citing unrelated Spanish retail law (Ley 7/1996, Ley 3/2014), the retired
// planPrice/30 refund formula, stale pre-single-product prices, and the
// illegal Art. 16(m)/103(m) digital-content waiver claim. The correct,
// i18n-wired, all-13-locale equivalent is /withdrawal-rights — redirect
// there instead of maintaining two divergent legal pages.
export const Route = createFileRoute("/$locale/refund-policy")({
  loader: ({ params }) => {
    throw redirect({
      to: "/$locale/withdrawal-rights",
      params: { locale: params.locale },
    });
  },
});
